var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b',[_c('i',{class:'far ' + _vm.getRatingClass(_vm.plan.provider.rating * 10) + ' ' + _vm.getSmileClass(_vm.plan.provider.rating * 10)}),_vm._v(" "+_vm._s(_vm.plan.provider.rating))])
}
var staticRenderFns = []

export { render, staticRenderFns }